// extracted by mini-css-extract-plugin
export var content = "_3x-3";
export var list = "_3x-4";
export var settingsContent = "_3x-7";
export var settingsPanel = "_3x-8";
export var state = "_3x-6";
export var triggerBadge = "_3x-2";
export var triggerButton = "_3x-1";
export var triggerShell = "_3x-0";
export var unreadDot = "_3x-5";